import {Injectable} from '@angular/core';
import {ConfigService} from '../../service/config.service';
import moment = require('moment');

@Injectable()
export class LenderCommissionRateUtil {
    private readonly configService: ConfigService;

    constructor(configService: ConfigService) {
        this.configService = configService;
    }

    public getLenderCommissionBy(date: Date): number {
        const commissionRateChangeDate = this.configService.getLenderCommissionDate();
        return moment(date).isBefore(commissionRateChangeDate) ? this.configService.getOldCommissionPercentage() :
            this.configService.getCommissionPercentage();
    }
}
